import { useState } from 'react';

import { Add, History } from '@mui/icons-material';
import { Menu } from '@mui/material';
import { wellzTheme } from '@wellz-theme/mui';
import { FormattedMessage } from 'react-intl';
import { wellzTheme as theme } from 'theme/wellzTheme';

import { InviteDropdownButtonProps } from './types';

import * as S from './styles';

export const InviteDropdownButton: React.FC<InviteDropdownButtonProps> = ({
  onClickCreate,
  onClickManagement,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <S.Button
        variant="contained"
        ref={setAnchorEl}
        onClick={() => setIsOpened(true)}
        size="medium"
      >
        <FormattedMessage id="CPPLATFORM.CPINVITE.BUTTONINVITE" />
        <div style={{ width: wellzTheme.spacing(1) }} />
        <S.ChevronByParameter
          mode={isOpened ? 'opened' : 'closed'}
          style={{ fill: 'white' }}
          width={wellzTheme.spacing(2.5)}
          height={wellzTheme.spacing(2.5)}
        />
      </S.Button>

      <Menu
        anchorEl={anchorEl}
        open={isOpened}
        onClose={() => setIsOpened(false)}
        onClick={() => setIsOpened(false)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        sx={{ '& .MuiMenu-paper': { backgroundColor: 'white' } }}
      >
        <S.MenuItem
          onClick={() => {
            onClickCreate();
            return setIsOpened(false);
          }}
        >
          <Add
            width={wellzTheme.spacing(3)}
            height={wellzTheme.spacing(3)}
            style={{ fill: theme.colors.inputDisabled }}
          />
          <div style={{ width: wellzTheme.spacing(1.5) }} />
          <FormattedMessage id="CPPLATFORM.CPINVITEDROPDOWN.CREATE" />
        </S.MenuItem>
        <S.MenuItem
          onClick={() => {
            onClickManagement();
            return setIsOpened(false);
          }}
        >
          <History
            width={wellzTheme.spacing(3)}
            height={wellzTheme.spacing(3)}
            style={{ fill: theme.colors.inputDisabled }}
          />
          <div style={{ width: wellzTheme.spacing(1.5) }} />
          <FormattedMessage id="CPPLATFORM.CPINVITEDROPDOWN.MANAGEMENTINVITES" />
        </S.MenuItem>
      </Menu>
    </>
  );
};
